import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'

import { AgGrid, Spinner } from '../../../../components'
import { getDefaultColumnDef, THEMES } from '../../../../utils'

import CustomCellRender from './cell/cell.component'

/**
 * Change Request Contact List Component
 */
class ChangeRequestListComponent extends PureComponent {
  /**
   * Constructor
   * @param props
   */
  constructor (props) {
    super(props)
    this.state = {
      columns: [
        { ...getDefaultColumnDef(0), field: 'change_type', headerName: 'Change Type', minWidth: 140, maxWidth: 140, pinned: 'left', lockPinned: true },
        { ...getDefaultColumnDef(1), field: '_id', headerName: 'Record ID', minWidth: 220, maxWidth: 220, pinned: 'left', lockPinned: true },
        { ...getDefaultColumnDef(2), field: 'status', headerName: 'Status', minWidth: 100,  maxWidth: 100, pinned: 'left', lockPinned: true },
        { ...getDefaultColumnDef(3, 'text'), field: 'full_name', headerName: 'Name', minWidth: 260,  maxWidth: 260, pinned: 'left', lockPinned: true },
        // regular columns with alternating styles
        { ...getDefaultColumnDef(4, 'text'), field: 'nickname', headerName: 'Nickname', minWidth: 180, maxWidth: 220 },
        { ...getDefaultColumnDef(5, 'text'), field: 'institution', headerName: 'Institution', minWidth: 180 },
        { ...getDefaultColumnDef(6, 'text'), field: 'title', headerName: 'Title', minWidth: 180 },
        { ...getDefaultColumnDef(7, 'text'), field: 'functions', headerName: 'Function(s)', minWidth: 180 },
        //{ ...getDefaultColumnDef(8), field: 'source', headerName: 'Source', minWidth: 100, maxWidth: 100 },
        { ...getDefaultColumnDef(8, 'date'), field: 'updated_date', headerName: 'Updated', minWidth: 90, maxWidth: 110 }
      ]
    }
  }

  /**
   * Handle AgGrid onGridReady event
   * @param grid
   * @see: {@link: https://github.com/ag-grid/ag-grid/issues/997}
   */
  handleGridReady = (grid) => {
    setTimeout(() => this.agGrid = grid, 0)
  }

  /**
   * Handle AgGrid gridSizeChanged event
   * @param type - event type
   */
  handleGridResize = ({ type }) => {
    if (type === 'gridSizeChanged') {
      setTimeout(() => this.agGrid && this.agGrid.api.sizeColumnsToFit(), 0)
    }
  }

  /**
   * Renders CustomCell Component
   */
  renderCustomCell = (props) => {
    return (<CustomCellRender {...props} />)
  }

  /**
   * Returns grid columns
   */
  getColumnsDefinition = () => {
    return this.state.columns.map(({ typeOfValue, ...column }, idx) => ({
      ...getDefaultColumnDef(idx, typeOfValue),
      ...column
    }))
  }

  /**
   * Render Contact Grid
   * @return {XML}
   */
  render () {
    const { data, total, filters: { page, limit }, loading, isGridReady, handleFilterChange } = this.props

    return (
      <>
        {loading && <Spinner mask theme={THEMES.RAIN} />}
        {isGridReady && (
          <AgGrid
            className='change-requests-grid_list'
            domLayout='autoHeight'
            sizeToFit={true}
          

            // suppress configs
            suppressMovableColumns={true}
            suppressContextMenu={true}

            // columns and data
            defaultColDef={{
              suppressMenu: true,
              sortable: false,
              cellRenderer: 'CustomCellRender'
            }}
            columnDefs={this.getColumnsDefinition()}
            rowData={data}

            // pagination
            pagination={true}
            paginationProps={{
              pageSizeId: 'change-request-list',
              forcePage: page,
              initialPageSize: limit,
              showPageSizeSelection: true,
              total,
              onPageChange: ({ selected }) => handleFilterChange({ page: selected }),
              onPageSizeChange: ({ selected }) => handleFilterChange({ page: 1, limit: selected })
            }}

            // custom components
            frameworkComponents={{
              CustomCellRender: this.renderCustomCell
            }}

            // event listeners
            onGridReady={this.handleGridReady}
            onGridSizeChanged={this.handleGridResize}

            isPinned={data?.length}
          />
        )}
      </>
    )
  }
}

ChangeRequestListComponent.propTypes = {
  isGridReady: PropTypes.bool.isRequired,
  loading: PropTypes.bool.isRequired,

  data: PropTypes.arrayOf(PropTypes.shape({
    _id: PropTypes.string.isRequired,
    status: PropTypes.string,
    full_name: PropTypes.string,
  })),

  filters: PropTypes.shape({
    page: PropTypes.number.isRequired,
    limit: PropTypes.number.isRequired
  }),

  total: PropTypes.number,
  handleFilterChange: PropTypes.func.isRequired,
  history: PropTypes.object.isRequired
}

ChangeRequestListComponent.defaultProps = {
  data: [],
  total: 0,
  filters: {
    page: 1,
    limit: 10
  }
}

export default ChangeRequestListComponent
